module.exports = __webpack_public_path__ + "static/media/other_services.a2fbf2c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/other_services.png
// module id = 608
// module chunks = 0